module.exports = __webpack_public_path__ + "static/flags/KR-8aae41125966c47c0df6c17ba898fe96.gif";